import React from "react";
import { css } from "@emotion/react";
import { mq } from "@/constants/breakpoints";
import { Heading } from "../Typography";

export function SpecialOfferBadge() {
  return (
    <div
      css={css`
        width: 100%;
        height: 100%;
        background-color: #243b4a;
        border-radius: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
      `}
    >
      <Heading
        css={css`
          font-weight: 700;
          font-size: 10px;
          line-height: 130%;
          text-align: center;
          color: white;
          ${mq["lg"]} {
            font-size: 11px;
          }
        `}
      >
        Special Offer
      </Heading>
      <Heading
        css={css`
          font-weight: 700;
          font-size: 32px;
          line-height: 130%;
          color: #55d278;
          ${mq["lg"]} {
            font-size: 36px;
          }
        `}
      >
        $19
      </Heading>
      <Heading
        css={css`
          font-weight: 700;
          font-size: 10px;
          line-height: 130%;
          color: white;
          ${mq["lg"]} {
            font-size: 11px;
          }
        `}
      >
        for your first
        <br />
        month
      </Heading>
    </div>
  );
}

export default SpecialOfferBadge;
